import React from 'react';
import BannerSlider from '../components/banner/BannerSlider';
import FancyButton from '../components/FancyButton';

const Corporate = () => {
  const heroSlides = [
    { label: 'Corporate Model', src: '/images/corp-model-olive-suit.webp' },
    { label: 'White Suit Guide', src: '/images/corp-white-suit-guide.webp' },
    { label: 'Black Tuxedo Flatlay', src: '/images/corp-black-tuxedo-flatlay.webp' },
    { label: 'Linen Blazer', src: '/images/corp-linen-blazer.webp' },
    { label: 'Royal Blue Blazer', src: '/images/corp-royal-blue-blazer.webp' },
  ];

  return (
    <>
      {/* Hero Section */}
      {/* Mobile banner */}
      <div className="block lg:hidden relative w-full overflow-hidden">
        <img src="/images/corporate-banner.webp" alt="Corporate Solutions" className="w-full h-auto object-contain" />
      </div>
      <div className="block lg:hidden px-6 py-6 bg-background-light dark:bg-background-dark">
        <span className="text-[10px] uppercase tracking-[0.5em] text-primary mb-4 block">Since 1905</span>
        <h1 className="font-display text-4xl leading-[0.95] mb-4 dark:text-white">Corporate<br />Solutions</h1>
        <div className="w-10 h-px bg-primary mb-4" />
        <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed">Engineering corporate identity through precision tailoring.</p>
      </div>
      {/* Desktop banner */}
      <header className="hidden lg:block relative w-full lg:h-[70vh] overflow-hidden bg-background-light dark:bg-background-dark">
        <div className="relative z-10 flex flex-col justify-center w-full lg:w-[45%] lg:h-full px-6 sm:px-8 md:px-16 lg:px-20 py-8 lg:py-0 flex-shrink-0">
          <span className="text-[10px] uppercase tracking-[0.5em] text-primary mb-6">Since 1905</span>
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.95] mb-6 dark:text-white">Corporate<br />Solutions</h1>
          <div className="w-10 h-px bg-primary mb-6" />
          <p className="text-gray-500 dark:text-gray-400 text-sm max-w-xs leading-relaxed">Engineering corporate identity through precision tailoring.</p>
        </div>
        <div className="absolute inset-y-0 right-0 w-[65%] h-full">
          <img src="/images/corporate-banner.webp" alt="Corporate Solutions" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-background-light dark:from-background-dark to-transparent" />
        </div>
      </header>

      {/* B2B Content */}
      <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">

        {/* Heritage Strip */}
        <div className="text-center mb-6">
          <p className="text-xs uppercase tracking-widest text-gray-400">
            120+ Years of Tailoring Heritage &nbsp;|&nbsp; 3 Fabric Houses &nbsp;|&nbsp; Corporate Specialists
          </p>
        </div>

        {/* Intro block */}
        <div className="max-w-3xl mx-auto text-center mb-20">
          <h2 className="font-display text-4xl md:text-5xl mb-6">
            Where Legacy Tailoring Meets Corporate Scale
          </h2>
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
            We design and manage uniform programs. With our tailoring legacy since 1905, we focus on
            engineering uniforms that reflect brand authority while ensuring long-term fabric performance.
            We come from over a century of tailoring — we design uniforms with real wear in mind, not just showroom appeal.
          </p>
        </div>

        {/* Industries We Serve */}
        <div className="mb-20 text-center">
          <p className="text-xs uppercase tracking-widest text-gray-400 mb-6">Industries We Serve</p>
          <div className="grid grid-cols-2 sm:flex sm:flex-wrap sm:justify-center gap-3">
            {['Hospitality', 'Aviation', 'Corporate Offices', 'Healthcare', 'Education', 'Security', 'Manufacturing'].map(industry => (
              <span
                key={industry}
                className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm text-gray-700 dark:text-gray-300 text-center"
              >
                {industry}
              </span>
            ))}
          </div>
        </div>


        {/* Capabilities */}
        <div className="mb-20">
          <div className="mb-14 grid grid-cols-2 xl:grid-cols-4 gap-4 md:gap-6">
            {[
              { id: '01', img: '/images/corporate-uniform.webp', label: 'Uniform' },
              { id: '02', img: '/images/corporate-unnamed-4.webp', label: 'Formal Business' },
              { id: '03', img: '/images/corporate-unnamed-10.webp', label: 'Casual Business' },
              { id: '04', img: '/images/corporate-industry-specific.webp', label: 'Industry-Specific' },
            ].map((item) => (
              <div key={item.id} className="rounded-2xl overflow-hidden shadow-md bg-white dark:bg-surface-dark group">
                <div className="relative w-full overflow-hidden" style={{paddingBottom: '120%', height: 0}}>
                  <img src={item.img} alt={item.label} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="hidden md:block absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                  <div className="hidden md:block absolute bottom-0 left-0 right-0 p-5">
                    <h3 className="font-display text-xl text-white mb-1">{item.label}</h3>
                  </div>
                </div>
                <div className="block md:hidden px-3 py-2">
                  <h3 className="font-display text-sm leading-tight dark:text-white">{item.label}</h3>
                </div>
              </div>
            ))}
          </div>
          <h3 className="font-display text-2xl md:text-3xl text-center mb-4">Built for Growing Organizations</h3>
          <p className="text-center text-gray-500 dark:text-gray-400 text-sm mb-12 max-w-lg mx-auto">
            We engineer workforce image systems — not just uniforms.
          </p>
        </div>

        {/* Corporate Orders CTA */}
        <div className="mb-20 text-center">
          <div className="flex items-center justify-center gap-6 mb-4">
            <h3 className="font-display text-2xl md:text-3xl">For Corporate Orders</h3>
            <FancyButton label="Call Us" href="tel:+918850558809" />
          </div>
          <p className="text-gray-500 dark:text-gray-400 text-sm mb-6">Mishka Fernandes — +91 88505 58809</p>
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed max-w-2xl mx-auto">
            We engineer fabrics based on climate, employee movement, wash frequency, and role intensity. Our tailoring heritage dates back to 1905 — we don't just understand fabric on the shelf, we understand how it performs after years of wear.
          </p>
        </div>


      </section>
    </>
  );
};

export default Corporate;
